import { Fragment, useState } from "react";
import { Menu, Bell } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useUserNotificationsQuery } from "src/lib/endpoints/dashboard/dashboard.api";
import { useHireNowModal } from "../../context/HireNowModalContext";
import HireNowModal from "../Modal/HireNowModal";
import ReferralModal from "../Modal/ReferralModal";
import Notification from "../Notification/Notification";
import MobileMenu from "./MobileMenu";
import UserInfo from "./UserInfo";
import { pageTitleFor, sectionFor } from "./navItems";

const Navbar = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const { showHireNowModal, closeHireNowModal } =
    useHireNowModal();
  const navigate = useNavigate();
  const { notifications } = useUserNotificationsQuery();
  const location = useLocation();

  const unread = notifications?.notReadCount ?? 0;

  return (
    <Fragment>
      <header className="sticky top-0 z-40 flex h-14 shrink-0 items-center gap-3 border-b bg-card px-4 sm:px-6">
        <button
          type="button"
          onClick={() => setShowMobileMenu(true)}
          aria-label="Open menu"
          className="-ml-2 shrink-0 rounded-full p-2 text-brand-navy transition-colors hover:bg-surface lg:hidden"
        >
          <Menu className="h-5 w-5" />
        </button>

        <div className="min-w-0 flex-1">
          <div className="text-[11px] uppercase tracking-wider text-muted-foreground">
            {sectionFor(location.pathname)}
          </div>
          <h1 className="truncate text-sm font-bold text-brand-navy sm:text-base">
            {pageTitleFor(location.pathname)}
          </h1>
        </div>

        <button
          type="button"
          onClick={() => navigate("/job-post")}
          className="inline-flex h-9 shrink-0 items-center rounded-lg border border-brand-navy px-3 text-xs font-semibold text-brand-navy transition-colors hover:bg-surface sm:px-4 sm:text-sm"
        >
          Hire now
        </button>

        <button
          type="button"
          onClick={() => setShowNotification((o) => !o)}
          aria-label="Notifications"
          className="relative shrink-0 rounded-full p-2 text-brand-navy transition-colors hover:bg-surface"
        >
          <Bell className="h-5 w-5" />
          {!!unread && (
            <span className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-brand-orange px-1 text-[9px] font-bold tabular-nums text-white">
              {unread > 99 ? "99+" : unread}
            </span>
          )}
        </button>

        <Link to={"/profile"} className="shrink-0 rounded-full">
          <UserInfo />
        </Link>
      </header>

      {/* DIALOGS */}

      {showMobileMenu && (
        <MobileMenu
          showMobileMenu={showMobileMenu}
          setShowMobileMenu={setShowMobileMenu}
        />
      )}

      {showReferralModal && (
        <ReferralModal
          open={showReferralModal}
          closeModal={() => setShowReferralModal(false)}
        />
      )}

      {showHireNowModal && (
        <HireNowModal open={showHireNowModal} closeModal={closeHireNowModal} />
      )}

      {showNotification && (
        <Notification
          open={showNotification}
          callback={() => setShowNotification(false)}
        />
      )}
    </Fragment>
  );
};

export default Navbar;
